var render = function (_h,_vm) {var _c=_vm._c;return _c('input-tag',_vm._g(_vm._b({},'input-tag',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }